<div class="equipment-page">
  <div class="equipment-card">
    <div class="card-header">
      <h2>{{ isEditMode ? 'Rediger udstyr' : 'Opret udstyr' }}</h2>
    </div>

    <div class="card-body">

      @if (isEditMode) {

      <div class="image-stack">

        <div class="image-block">
          <app-dialog-input-title title="QR kode"></app-dialog-input-title>

          <div class="image-meta">
            <div>{{ equipmentRequest.id }}</div>
            <div>{{ equipmentRequest.name }}</div>
          </div>

          <img [src]="qrImageSrc"
               alt="QR kode"
               class="equipment-image qr-image">
        </div>

        <div class="image-block" *ngIf="hasEquipmentImage && equipmentImageSrc">
          <app-dialog-input-title title="Udstyrsbillede"></app-dialog-input-title>

          <img [src]="equipmentImageSrc"
               alt="Udstyrsbillede"
               class="equipment-photo">
        </div>

      </div>

      }

      <app-dialog-input-title title="Udstyrskategori" [required]="true"></app-dialog-input-title>

      <mat-form-field appearance="fill" class="field">
        <mat-label>Vælg kategori</mat-label>
        <mat-select [(ngModel)]="selectedCategoryId"
                    (selectionChange)="onCategoryChange()">
          <mat-option *ngFor="let c of categoryItems" [value]="c.id">
            {{ c.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>



      <app-dialog-input-title title="Udstyrstype" [required]="true"></app-dialog-input-title>

      <mat-form-field appearance="fill" class="field">
        <mat-label>Vælg udstyrstype</mat-label>
        <mat-select [(ngModel)]="selectedSubCategoryId"
                    (selectionChange)="onSubCategoryChange()">
          <mat-option *ngFor="let sc of subCategoryItems" [value]="sc.id">
            {{ sc.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>


      <app-dialog-input-title title="Udstyrsnavn" [required]="true"></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [(ngModel)]="equipmentRequest.name" />

      <app-dialog-input-title title="Leverandør navn" [required]="true"></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [(ngModel)]="equipmentRequest.supplierName" />

      <div class="two-column">
        <div>
          <app-dialog-input-title title="Modelnavn" [required]="true"></app-dialog-input-title>
          <input class="text-input"
                 type="text"
                 [(ngModel)]="equipmentRequest.model" />
        </div>
        <div>
          <app-dialog-input-title title="Modelserie nr." [required]="true"></app-dialog-input-title>
          <input class="text-input"
                 type="text"
                 [(ngModel)]="equipmentRequest.series" />
        </div>
      </div>

      <div class="two-column">
        <div>
          <app-dialog-input-title title="Indkøbsdato" [required]="true"></app-dialog-input-title>
          <mat-form-field (click)="boughtPicker.open()"
                          color="accent"
                          class="dialogDatepicker">
            <input matInput
                   [matDatepicker]="boughtPicker"
                   [(ngModel)]="equipmentRequest.purchaseDate"
                   name="boughtDate" />
            <mat-datepicker-toggle matIconSuffix [for]="boughtPicker"></mat-datepicker-toggle>
            <mat-datepicker #boughtPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div>
          <app-dialog-input-title title="Udløbsdato" [required]="true"></app-dialog-input-title>
          <mat-form-field (click)="bestBeforePicker.open()"
                          color="accent"
                          class="dialogDatepicker">
            <input matInput
                   [matDatepicker]="bestBeforePicker"
                   [(ngModel)]="equipmentRequest.bestbefore"
                   name="bestBeforeDate" />
            <mat-datepicker-toggle matIconSuffix [for]="bestBeforePicker"></mat-datepicker-toggle>
            <mat-datepicker #bestBeforePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div class="two-column">
        <div>
          <app-dialog-input-title title="Afdeling" [required]="true"></app-dialog-input-title>

          <mat-form-field appearance="fill" class="field">
            <mat-label>Vælg afdeling</mat-label>
            <mat-select [(ngModel)]="selectedDepartmentId"
                        (selectionChange)="onDepartmentChange()">
              <mat-option *ngFor="let d of departmentItems" [value]="d.id">
                {{ d.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>

        <div>
          <app-dialog-input-title title="Lokation" [required]="true"></app-dialog-input-title>

          <mat-form-field appearance="fill" class="field">
            <mat-label>Vælg lokation</mat-label>
            <mat-select [(ngModel)]="selectedLocationId"
                        (selectionChange)="onLocationChange()">
              <mat-option *ngFor="let l of locationItems" [value]="l.id">
                {{ l.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>
      </div>

      <app-dialog-input-title title="Placering" [required]="true"></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [(ngModel)]="equipmentRequest.placement" />

      <app-dialog-input-title title="Ansvarlig" [required]="true"></app-dialog-input-title>

      <mat-form-field appearance="fill" class="field">
        <mat-label>Vælg ansvarlig</mat-label>
        <mat-select [(ngModel)]="selectedResponsibleUserId"
                    (selectionChange)="onResponsibleChange()">
          <mat-option *ngFor="let u of responsibleItems" [value]="u.id">
            <!-- skal forbindes op med alarmRecipient -->
            {{ u.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>


      <div class="two-column">
        <div>
          <app-dialog-input-title title="Kontrolfrekvens (antal måneder)" [required]="true"></app-dialog-input-title>
          <input class="text-input"
                 type="text"
                 [(ngModel)]="equipmentRequest.serviceFrequencyMonths"
                 (ngModelChange)="recalcNextControl()" />
        </div>

        <div>
          <app-dialog-input-title title="Antal dage før næste kontrol (emailpåmindelse)" [required]="true"></app-dialog-input-title>
          <input class="text-input"
                 type="text"
                 [(ngModel)]="equipmentRequest.serviceFrequencyDelay" />
        </div>
      </div>

      <app-dialog-input-title title="Kommentar"></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [(ngModel)]="equipmentRequest.comment" />

      <app-dialog-input-title title="Upload filer til udstyr"></app-dialog-input-title>

      <div class="upload-row">
        <button mat-flat-button
                class="dialogButton upload-btn"
                color="accent"
                (click)="imageInput.click()">
          Upload billede
        </button>

        <button mat-flat-button
                class="dialogButton upload-btn"
                color="accent"
                (click)="docsInput.click()">
          Upload dokumenter
        </button>
      </div>

      <div class="upload-filnames">
        <span *ngIf="selectedImageName">{{ selectedImageName }}</span>
        <span *ngIf="selectedDocumentNames.length">
          {{ selectedDocumentNames.join(', ') }}
        </span>
      </div>

      <input #imageInput
             type="file"
             accept="image/*"
             hidden
             (change)="onEquipmentImageSelected($event)" />

      <input #docsInput
             type="file"
             multiple
             hidden
             (change)="onEquipmentDocumentsSelected($event)" />

      @if (isEditMode) {
      @if (hasServiceHistory) {
      <hr class="section-divider" />
      <h2>Sidste kontrol</h2>

      <app-dialog-input-title title="Kontrol udført af"></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [value]="equipmentService.serviceBy || ''"
             disabled />

      <div class="two-column">
        <div>
          <app-dialog-input-title title="Kontrol dato"></app-dialog-input-title>
          <input class="text-input"
                 type="text"
                 [value]="(equipmentService.serviceDate | date:'dd-MM-yyyy') || ''"
                 disabled />
        </div>
        <div>
          <app-dialog-input-title title="Kontrol status"></app-dialog-input-title>
          <input class="text-input"
                 type="text"
                 [value]="controlStatusText"
                 disabled />
        </div>
      </div>
      <div>
        <app-dialog-input-title title="Kontrol type"></app-dialog-input-title>
        <input class="text-input"
               type="text"
               [value]="lastServiceTypeText  || ''"
               disabled />
      </div>

      <app-dialog-input-title title="Kontrol bemærkning"></app-dialog-input-title>
      <input class="text-input"
             [value]="equipmentService.serviceComment || ''"
             disabled />

      <div>
        <app-dialog-input-title title="Næste kontrol"></app-dialog-input-title>
        <input class="text-input"
               type="text"
               [value]="nextControlText || ''"
               disabled />
      </div>
      }

      @if (hasBorrowHistory) {
      <hr class="section-divider" />
      <h2>Sidst udlånt</h2>

      <app-dialog-input-title title="Udlånt dato"></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [value]="(equipmentBorrow.borrowedDate | date:'dd-MM-yyyy') || ''"
             disabled />

      <app-dialog-input-title title="Udlånt til (initialer)"></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [value]="equipmentBorrow.initials || ''"
             disabled />

      <app-dialog-input-title title="Udlånt til (lokation)"></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [value]="equipmentBorrow.locationName || ''"
             disabled />

      <div>
        <app-dialog-input-title title="Forventet returdato"></app-dialog-input-title>
        <input class="text-input"
               type="text"
               [value]="(equipmentBorrow.expectedReturnDate | date:'dd-MM-yyyy') || ''"
               disabled />
      </div>

      <app-dialog-input-title title="Udlån bemærkning"></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [value]="equipmentBorrow.borrowedComment || 'Ingen bemærkning'"
             disabled />

      <div>
        <app-dialog-input-title title="Returdato"></app-dialog-input-title>
        <input class="text-input"
               type="text"
               [value]="(equipmentBorrow.returnedDate | date:'dd-MM-yyyy') || ''"
               disabled />
      </div>

      <app-dialog-input-title title="Retur bemærkning"></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [value]="equipmentBorrow.returnedComment || 'Ingen bemærkning'"
             disabled />
      }

      <hr class="section-divider" />
      <h2>Udfør kontrol</h2>

      <app-dialog-input-title title="Kontrol udført af"></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [(ngModel)]="equipmentService.serviceBy" />

      <div>
        <app-dialog-input-title title="Dato for kontrol" [required]="true"></app-dialog-input-title>
        <mat-form-field (click)="serviceDateDatePicker.open()"
                        color="accent"
                        class="dialogDatepicker">
          <input matInput
                 [matDatepicker]="serviceDateDatePicker"
                 [(ngModel)]="equipmentService.serviceDate"
                 name="serviceDate" />
          <mat-datepicker-toggle matIconSuffix [for]="serviceDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #serviceDateDatePicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div>
        <app-dialog-input-title title="Vælg farve for kontrol"></app-dialog-input-title>

        <div class="color-palette">
          <div *ngFor="let c of serviceColorItems"
               class="color-dot"
               [style.backgroundColor]="c.id"
               [class.selected]="equipmentService.serviceColor === c.id"
               (click)="equipmentService.serviceColor = c.id">
          </div>
        </div>

        <app-dialog-input-title title="Kontroltype"></app-dialog-input-title>

        <div class="control-types">
          <mat-checkbox [(ngModel)]="equipmentService.typeService">Service</mat-checkbox>
          <mat-checkbox [(ngModel)]="equipmentService.typeCalibration">Kalibrering</mat-checkbox>
          <mat-checkbox [(ngModel)]="equipmentService.typeRepair">Reparation</mat-checkbox>
          <mat-checkbox [(ngModel)]="equipmentService.typeVerification">Verifikation</mat-checkbox>
          <mat-checkbox [(ngModel)]="equipmentService.typeMalfunction">Defekt</mat-checkbox>
        </div>

        <div class="hint" *ngIf="controlTypeText">
          Valgt: {{ controlTypeText }}
        </div>

      </div>
      <app-dialog-input-title title="Kontrol bemærkning"></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [(ngModel)]="equipmentService.serviceComment" />

      <button mat-flat-button
              color="accent"
              class="dialogButton"
              (click)="performControl()"
              [disabled]="isControlSaveDisabled">
        Udfør kontrol
      </button>

      <hr class="section-divider" />
      <h2>Udlejning af udstyr</h2>

      <app-dialog-input-title title="Initialer"></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [(ngModel)]="equipmentBorrow.initials"
             [disabled]="isBorrowedOut" />

      <app-dialog-input-title title="Lokation"></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [(ngModel)]="equipmentBorrow.locationName"
             [disabled]="isBorrowedOut" />

      <div>
        <app-dialog-input-title title="Forventet retur" [required]="true"></app-dialog-input-title>
        <mat-form-field (click)="expectedReturnDatePicker.open()"
                        color="accent"
                        class="dialogDatepicker">
          <input matInput
                 [matDatepicker]="expectedReturnDatePicker"
                 [(ngModel)]="equipmentBorrow.expectedReturnDate"
                 name="expectedReturnDate"
                 [disabled]="isBorrowedOut" />
          <mat-datepicker-toggle matIconSuffix [for]="expectedReturnDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #expectedReturnDatePicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div>
        <app-dialog-input-title title="Projekt nr."></app-dialog-input-title>
        <input class="text-input"
               type="text"
               [(ngModel)]="equipmentBorrow.projectNr"
               [disabled]="isBorrowedOut" />
      </div>

      <div>
        <app-dialog-input-title title="Udlån bemærkning"></app-dialog-input-title>
        <input class="text-input"
               type="text"
               [(ngModel)]="equipmentBorrow.borrowedComment"
               [disabled]="isBorrowedOut" />
      </div>

      <button mat-flat-button
              color="accent"
              class="dialogButton"
              (click)="performBorrow()"
              [disabled]="isBorrowSaveDisabled">
        Udlån
      </button>

      <div *ngIf="isBorrowedOut">

        <div>
          <app-dialog-input-title title="Returdato" [required]="true"></app-dialog-input-title>
          <mat-form-field (click)="returnDatePicker.open()"
                          color="accent"
                          class="dialogDatepicker">
            <input matInput
                   [matDatepicker]="returnDatePicker"
                   [(ngModel)]="equipmentBorrow.returnedDate"
                   name="returnedDate" />
            <mat-datepicker-toggle matIconSuffix [for]="returnDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #returnDatePicker></mat-datepicker>
          </mat-form-field>
        </div>

        <app-dialog-input-title title="Retur bemærkning"></app-dialog-input-title>
        <input class="text-input"
               type="text"
               [(ngModel)]="equipmentBorrow.returnedComment" />

        <button mat-flat-button
                color="primary"
                class="dialogButton"
                (click)="performReturn()">
          Returner
        </button>
      </div>


      }
    </div>

    <div class="card-footer">
      <app-save-button [disabled]="isSaveDisabled"
                       [clickEvent]="saveChanges.bind(this)">
      </app-save-button>

      @if (userService.getSelectedRole == userService.getUserRoleTypes.Admin) {
      <app-delete-button [clickEvent]="deleteEntry.bind(this)"></app-delete-button>
      }
    </div>
  </div> 
</div>   
